/**
 * Das Schild, das sagt: nichts hiervon ist echt.
 *
 * Ohne es sieht ein Bildschirmfoto aus dem Debug-Modus genauso aus wie
 * eines vom laufenden Server — und dann diskutiert man über Post, die es
 * nicht gibt.
 *
 * Der Schalter steht woertlich da und nicht als `DEBUG_MODE` aus `./index`:
 * nur dann sieht der Buendler an dieser Stelle ein `false` und wirft die
 * Komponente samt dem erfundenen Postfach aus dem Bau. Mit der
 * eingefuehrten Konstanten lag das Pseudo-Postfach nachweislich in der
 * ausgelieferten Datei.
 */
export function DebugBadge() {
  if (import.meta.env.VITE_DEBUG_MODE !== "true") return null;
  return (
    <div className="debug-schild" role="status">
      debug mode — made-up data
    </div>
  );
}
